import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as loglevel from 'loglevel';
import { AllCommunityModule, ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';
import { scrubSentryEvent } from './app/core/sentry-scrub';

ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule]);

Sentry.init({
  dsn: "https://0a23250fd0e9ac4feecadda85b1acff2@o359731.ingest.us.sentry.io/4511808458194944",
  sendDefaultPii: false,
  beforeSend: (event) => scrubSentryEvent(event),
});

bootstrapApplication(App, appConfig)
  .catch((err) => {
    loglevel.getLogger('bootstrap').error('Application bootstrap failed', err);
  });
